import { Poly } from "../../Poly";
import { NodeCookPerformanceformanceController } from "./cook/PerformanceController";
export class NodeCookController {
  constructor(node) {
    this.node = node;
    this._cooking = false;
    this._performanceController = new NodeCookPerformanceformanceController(this);
    this._inputsEvaluationRequired = true;
    this._corePerformance = this.node.scene().performance;
  }
  performanceRecordStarted() {
    return this._corePerformance.started();
  }
  dispose() {
    this._clearHooks();
  }
  disallowInputsEvaluation() {
    this._inputsEvaluationRequired = false;
  }
  isCooking() {
    return this._cooking === true;
  }
  _startCookIfNoErrors(inputContents) {
    if (this.node.states.error.active()) {
      this.endCook();
    } else {
      try {
        this._performanceController.recordCookStart();
        this.node.cook(inputContents || []);
      } catch (e) {
        this.node.states.error.set(`node internal error: '${e}'.`);
        Poly.warn(e);
        this.endCook();
      }
    }
  }
  async cookMain() {
    if (this.isCooking()) {
      return;
    }
    this._initCookingState();
    this.node.states.error.clear();
    this.node.scene().cookController.addNode(this.node);
    const inputContents = this._inputsEvaluationRequired ? await this._evaluateInputs() : void 0;
    if (this.node.params.paramsEvalRequired()) {
      await this._evaluateParams();
    }
    this._startCookIfNoErrors(inputContents);
  }
  async cookMainWithoutInputs() {
    this.node.scene().cookController.addNode(this.node);
    if (this.isCooking()) {
      Poly.warn("cook_main_without_inputs already cooking", this.node.path());
      return;
    }
    this._initCookingState();
    this.node.states.error.clear();
    if (this.node.params.paramsEvalRequired()) {
      await this._evaluateParams();
    }
    this._startCookIfNoErrors(void 0);
  }
  endCook(message) {
    var _a, _b;
    this._finalizeCookPerformance();
    const dirtyTimestamp = this.node.dirtyController.dirtyTimestamp();
    const timestampUnchangedSinceCookStarted = dirtyTimestamp == null || dirtyTimestamp === this._cookingDirtyTimestamp;
    if (timestampUnchangedSinceCookStarted) {
      this.node.removeDirtyState();
      this._terminateCookProcess();
    } else {
      if ((_b = (_a = this.node.flags) == null ? void 0 : _a.bypass) == null ? void 0 : _b.active()) {
        return;
      }
      Poly.log("COOK AGAIN", dirtyTimestamp, this._cookingDirtyTimestamp, this.node.path());
      this._cooking = false;
      this.cookMain();
    }
  }
  _initCookingState() {
    this._cooking = true;
    this._cookingDirtyTimestamp = this.node.dirtyController.dirtyTimestamp();
  }
  _terminateCookProcess() {
    if (this.isCooking()) {
      this._cooking = false;
      this.node.containerController.notifyRequesters();
      this._run_on_cook_complete_hooks();
    }
  }
  async _evaluateInputs() {
    this._performanceController.recordInputsStart();
    const ioOnputs = this.node.io.inputs;
    const inputContainers = this._inputsEvaluationRequired ? ioOnputs.isAnyInputDirty() ? await ioOnputs.evalRequiredInputs() : ioOnputs.containersWithoutEvaluation() : [];
    const inputs = ioOnputs.inputs();
    const inputContents = [];
    let inputContainer;
    for (let i = 0; i < inputs.length; i++) {
      inputContainer = inputContainers[i];
      if (inputContainer) {
        if (ioOnputs.cloneRequired(i)) {
          inputContents[i] = inputContainer.coreContentCloned();
        } else {
          inputContents[i] = inputContainer.coreContent();
        }
      }
    }
    this._performanceController.recordInputsEnd();
    return inputContents;
  }
  async _evaluateParams() {
    this._performanceController.recordParamsStart();
    await this.node.params.evalAll();
    this._performanceController.recordParamsEnd();
  }
  cooksCount() {
    return this._performanceController.cooksCount();
  }
  cookTime() {
    return this._performanceController.data().cookTime;
  }
  _finalizeCookPerformance() {
    if (!this._corePerformance.started()) {
      return;
    }
    this._performanceController.recordCookEnd();
    this._corePerformance.recordNodeCookData(this.node, this._performanceController.data());
  }
  registerOnCookEnd(callbackName, callback) {
    this._on_cook_complete_hook_names = this._on_cook_complete_hook_names || [];
    this._on_cook_complete_hooks = this._on_cook_complete_hooks || [];
    this._on_cook_complete_hook_names.push(callbackName);
    this._on_cook_complete_hooks.push(callback);
  }
  _clearHooks() {
    if (!this._on_cook_complete_hook_names || !this._on_cook_complete_hooks) {
      return;
    }
    for (let hookName of this._on_cook_complete_hook_names) {
      this.deregisterOnCookEnd(hookName);
    }
  }
  deregisterOnCookEnd(callbackName) {
    var _a;
    if (!this._on_cook_complete_hook_names || !this._on_cook_complete_hooks) {
      return;
    }
    const index = (_a = this._on_cook_complete_hook_names) == null ? void 0 : _a.indexOf(callbackName);
    this._on_cook_complete_hook_names.splice(index, 1);
    this._on_cook_complete_hooks.splice(index, 1);
    if (this._on_cook_complete_hook_names.length == 0) {
      this._on_cook_complete_hook_names = void 0;
    }
    if (this._on_cook_complete_hooks.length == 0) {
      this._on_cook_complete_hooks = void 0;
    }
  }
  _run_on_cook_complete_hooks() {
    if (this._on_cook_complete_hooks) {
      for (let hook of this._on_cook_complete_hooks) {
        hook();
      }
    }
  }
  onCookEndCallbackNames() {
    return this._on_cook_complete_hook_names;
  }
}
